module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-300.woff?34ee73eae7f6fa2331136d0f9782f454";